export const RADIO_SIZE_DEFAULT = 'default';
export const RADIO_SIZE_BIG = 'big';

export const RADIO_SIZES = [
    RADIO_SIZE_DEFAULT,
    RADIO_SIZE_BIG,
];
